import { Link } from 'wouter'
import { Button } from '../../components/ui/button'
import Container from '../../components/ui/container'
import Logo from '../../assets/logo.png'

export default function Header() {
    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm border-b">
            <Container>
                <div className="flex items-center justify-between h-16">
                    {/* <Link href="/">
                        <a className="text-xl font-extrabold">PrimoTalent</a>
                    </Link> */}
                    <Link to="/" className="flex ">
                        <img
                            src={Logo}
                            alt="PrimoTalent Logo"
                            className=" h-10"
                        />
                    </Link>
                    <nav className="hidden md:flex items-center gap-8">
                        <Link href="#benefits">
                            <a
                                className="text-md font-medium hover:text-primary transition-colors"
                                onClick={(e) => {
                                    e.preventDefault() // Prevent default jump behavior
                                    document
                                        .getElementById('benefits')
                                        ?.scrollIntoView({ behavior: 'smooth' })
                                }}
                            >
                                Why Choose Us
                            </a>
                        </Link>
                        <Link href="#services">
                            <a
                                className="text-md font-medium hover:text-primary transition-colors"
                                onClick={(e) => {
                                    e.preventDefault() // Prevent default jump behavior
                                    document
                                        .getElementById('services')
                                        ?.scrollIntoView({ behavior: 'smooth' })
                                }}
                            >
                                Services
                            </a>
                        </Link>
                        <Link href="#forms">
                            <a
                                className="text-md font-medium hover:text-primary transition-colors"
                                onClick={(e) => {
                                    e.preventDefault() // Prevent default jump behavior
                                    document
                                        .getElementById('forms')
                                        ?.scrollIntoView({ behavior: 'smooth' })
                                }}
                            >
                                Get Started
                            </a>
                        </Link>
                    </nav>
                    <div className="flex items-center gap-4">
                        <Button
                            className="hidden md:flex"
                            variant="outline"
                            asChild
                            onClick={(e) => {
                                e.preventDefault() // Prevent default jump behavior
                                document
                                    .getElementById('forms')
                                    ?.scrollIntoView({ behavior: 'smooth' })
                            }}
                        >
                            <Link href="#forms">Apply as Talent</Link>
                        </Button>
                        <Button
                            asChild
                            onClick={(e) => {
                                e.preventDefault() // Prevent default jump behavior
                                document
                                    .getElementById('forms')
                                    ?.scrollIntoView({ behavior: 'smooth' })
                            }}
                        >
                            <Link href="#forms">Hire Talent</Link>
                        </Button>
                    </div>
                </div>
            </Container>
        </header>
    )
}
